import React from "react";

function Footer() {
  return (
    <footer className="footer d-block d-md-flex justify-content-between text-md-start text-center">
      
    </footer>
  );
}

export default Footer;
